
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalTitle } from "react-bootstrap";

function PublisherResetPassword() {

    const[product,setProduct]=useState([]);
    const[search,setSearch]=useState([""]);
    const[show,setShow]=useState(false);
    const[pass,setPass]=useState({});
    const[dpr_idState,setDpr_id]=useState();
    const[email,setEmail]=useState("");
    const getProductData=async()=>
    {
       try{
         const data=await axios.get( 
            `${process.env.REACT_APP_NODE_URL}/admin/publisher/get-all-publisher`
            );
         setProduct(data.data);
       }
       catch(e)
       {
   console.log(e);
       }
    };
    useEffect(()=>
    { getProductData();
      },[]);
    
   const OnHandleForm=(event)=>
   {
  
       setPass({...pass,[event.target.name]:event.target.value});
      
   }
   const SendConfirm=()=>
   {
    axios
    .put(
      `${process.env.REACT_APP_NODE_URL}/admin/publisher/change-password/`+dpr_idState,
      {
         email:email,
         password:pass.password,
         confirm_password:pass.confirm_password,
      }
       
    )
    .then(function (response) {
      if (response.status === 200) {
      alert("Password Changed");
      }
      console.log(response.data);
    })
    .catch(function (error) {
      console.log(error);
    });
   }
   
    return (
      <div>
        <h2>Publisher Reset Password</h2>
        <div className="text-end">
          <input
            name="search"
            type="text"
            placeholder="search here"
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
        </div>
        <div className="overflow-y-scroll px-5 py-3">
          <table className="table table-bordered border-primary table-hover ">
            <thead className="table-dark ">
              <tr>
                <th scope="col">S.NO</th>
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col">Phone</th>
                <th scope="col">Company</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
           
              {product.data !== undefined
                ? product.data
                    .filter((item) => {
                      if (search === "") {
                        return item;
                      } else if (item.email.includes(search)) {
                        return item;
                      }
                    })
                    .map((item, index) => {
                      return (
                        <tr>
                          <th scope="row">{index}</th>
                          <td>{item.firstname + item.lastname}</td>
                          <td>{item.email}</td>
                          <td>{item.mobile}</td>
                          <td>{item.company}</td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={()=>{
                                setShow(true);
                                setDpr_id(item.dpr_id);
                                setEmail(item.email);
                              }}
                            >
                              Change Password
                            </button>
                          </td>
                        </tr>
                      );
                    })
                : null}
            </tbody>
          </table>
          <Modal show={show} centered size="lg">
            <ModalTitle>
              Reset Password
            </ModalTitle>
            <ModalBody>
            <label className="form-label float-start mt-3">New Password:</label>
              <input
                className="form-control"
                type="password"
                name="password"
                id="pwd"
                onChange={(event)=>OnHandleForm(event)}
              ></input>
              <label className="form-label float-start mt-3">Confirm Password:</label>
              <input
                className="form-control"
                type="password"
                name="confirm_password"
                id="password"
                onChange={(event)=>OnHandleForm(event)}
              ></input>
            </ModalBody>
            <ModalFooter>
            <Button
                variant="primary"
                onClick={() => {SendConfirm()  
                }}
              >
              Send
              </Button>
          <Button
          variant="secondary"
          onClick={() => {
            setShow(false);
          }}>
            close
          </Button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    );
}

export default PublisherResetPassword;